import { useState } from "react";
import ModalCenterSheet from "@/components/ui/modals/ModalCenterSheet";
import { SubscriptionPlanType } from "../SubscriptionScreenViewModel";
import { AutoContinuationModalContent } from "./AutoContinuationModalContent";

interface SubscriptionPlanProps {
  plan: SubscriptionPlanType;
  planetUrl: string;
  className?: string;
  style?: React.CSSProperties;
  onSuccessSelection: (
    isAutoContinuation: boolean,
    subscriptionPlan: SubscriptionPlanType
  ) => void;
}

export const SubscriptionPlan = (props: SubscriptionPlanProps) => {
  const [isAutoContinuationOpen, setIsAutoContinuationOpen] = useState(false);

  return (
    <>
      <ModalCenterSheet
        open={isAutoContinuationOpen}
        onClose={() => setIsAutoContinuationOpen(false)}
      >
        <AutoContinuationModalContent
          plan={props.plan}
          setIsAutoContinuationOpen={setIsAutoContinuationOpen}
          onSuccessSelection={(isAutoContinuation) =>
            props.onSuccessSelection(isAutoContinuation, props.plan)
          }
        />
      </ModalCenterSheet>
      <div
        key={props.plan.title}
        style={{
          ...props.style,
        }}
        className={`relative flex flex-col items-center justify-center bg-transparent ${props.className} transition hover:scale-105 cursor-pointer w-full h-full`}
        onClick={() => setIsAutoContinuationOpen(true)}
      >
        <div className=" z-10">
          <div className="text-[12px] font-bold text-center ">
            {props.plan.title}
          </div>
          <div className="text-[14px] font-light ">{props.plan.price}</div>
          <div className="text-[10px] ">
            {props.plan.questions !== "-" ? `(${props.plan.questions})` : null}
          </div>
        </div>
        <img src={props.planetUrl} className="object-contain absolute top-0 left-0 w-full h-full" />
      </div>
    </>
  );
};
